import { Box, Button, Input } from "@chakra-ui/react";
import styled from "styled-components";

export const ContainerParceiros = styled(Box)`
  width: 100%;
  height: 85vh;
  margin-top: 15px;
`;
export const ParceirosContainerText = styled(Box)`
  background-color: #03a9f4;
  padding: 15px 0;
  font-family: Akrobat;
  h1 {
    color: #03a9f4;
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const InputParceiros = styled(Input)``;
export const ButtonMenuFooter = styled(Button)`
`;
